import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Blog from './pages/Blog';
import ServicesPage from './pages/Services';
import SEOLanding from './pages/SEOLanding';
import PPCLanding from './pages/PPCLanding';
import WebDevLanding from './pages/WebDevLanding';
import ProjectsPage from './pages/ProjectsPage';
import ContentCreationLanding from './pages/ContentCreationLanding';
import SocialMediaLanding from './pages/SocialMediaLanding';
import EmailMarketingLanding from './pages/EmailMarketingLanding';
import ProcessPage from './pages/ProcessPage';
import ScrollToTop from './components/ScrollToTop';

// Blog Pages
import WhyYourBusinessWebsite from './pages/blogs/WhyYourBusinessWebsite';
import GoogleAdsVsFacebook from './pages/blogs/GoogleAdsVsFacebook';
import SevenSignsSEOUpgrade from './pages/blogs/SevenSignsSEOUpgrade';
import FullStackDevelopment from './pages/blogs/FullStackDevelopment';
import ContentThatConverts from './pages/blogs/ContentThatConverts';
import LeadGeneration2025 from './pages/blogs/LeadGeneration2025';
import MobileAppRetention from './pages/blogs/MobileAppRetention';
import HighConvertingWebsites from './pages/blogs/HighConvertingWebsites';
import PPCOptimization from './pages/blogs/PPCOptimization';
import CustomSoftwareBenefits from './pages/blogs/CustomSoftwareBenefits';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/process" element={<ProcessPage />} />

        {/* Service Landing Pages */}
        <Route path="/seo-services" element={<SEOLanding />} />
        <Route path="/ppc-services" element={<PPCLanding />} />
        <Route path="/web-development" element={<WebDevLanding />} />
        <Route path="/content-creation" element={<ContentCreationLanding />} />
        <Route path="/social-media" element={<SocialMediaLanding />} />
        <Route path="/email-marketing" element={<EmailMarketingLanding />} />

        {/* Blog Pages */}
        <Route path="/blog/why-your-business-website-is-costing-you-customers" element={<WhyYourBusinessWebsite />} />
        <Route path="/blog/google-ads-vs-facebook-ads" element={<GoogleAdsVsFacebook />} />
        <Route path="/blog/7-signs-your-seo-strategy-needs-an-upgrade" element={<SevenSignsSEOUpgrade />} />
        <Route path="/blog/power-of-full-stack-development" element={<FullStackDevelopment />} />
        <Route path="/blog/content-that-converts" element={<ContentThatConverts />} />
        <Route path="/blog/lead-generation-in-2025" element={<LeadGeneration2025 />} />
        <Route path="/blog/why-your-mobile-app-is-losing-users" element={<MobileAppRetention />} />
        <Route path="/blog/how-we-build-high-converting-websites" element={<HighConvertingWebsites />} />
        <Route path="/blog/how-to-optimize-ppc-for-results" element={<PPCOptimization />} />
        <Route path="/blog/why-you-need-custom-software" element={<CustomSoftwareBenefits />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
